import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';
import { HomePage } from '../../components/home/HomePage';

const customHomeLayout = HomePageLayoutBlueprint.make({
  params: {
    loader: async () => () => <HomePage />,
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [customHomeLayout],
});
